export default {
  text: 'black',
  primary: '#cb0006',
  secondary: '#cb0006',
  background: 'white',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
